import qs from 'qs'
import axios from 'axios'
import store from '@/store'
// import { getToken } from '@/utils/auth'
// import debugLog from '@/utils/debugLog'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000, // request timeout
  paramsSerializer: (params) => {
    return qs.stringify(params, {arrayFormat: 'brackets'})
  }
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    if (store.getters.token) {
      config.headers['X-CSRF-Token'] = store.getters.token
    }
    return config
  },
  error => {
    // debugLog(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use( response => {
  if (response.headers['x-csrf-token']) {
    store.commit('session/SET_TOKEN', response.headers['x-csrf-token'])
  }
  return response
}, err => {
  if (err.response.status === 401) {
    store.dispatch('session/needAuth')
  }
  return Promise.reject(err.response)
})

export default service
